"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLoopController = createLoopController; // Note: this file and all others under custom-scrollbars are pulled out of the package
// react-scrollbars-custom, because we require a very custom modification to allow
// the vertical scrollbar to work with our "upside-down" message list component in the
// bsweb app (i.e., for that component, the thumb drags and track clicks need to be handled
// backwards from usual). To allow this, there are modifications in index.js, Track.js, and 
// Thumb.js.  All changes are marked with the comment
//
// zipwhip modification from react-scrollbars-custom
//
// to allow possible re-absorption of changes/fixes that might occur in the source library.
// For the same reason, additional customization such as auto-hiding behavior that does not
// have to be added to the original react-scrollbars-custom code itself is handled a level up
// in the ScrollArea component.

function LoopControllerClass() {
  var _this = this;
  /**
   * @typedef {Object} Scrollbar
   * @property {function} update
   */

  /**
   * @type {Scrollbar[]}
   */


  var scrollbarsRegister = [];
  /**
   * true if loop is active
   * @type {boolean}
   */

  var isActive = false;
  /**
   * ID of requested animation frame
   * @type {null|number}
   */

  var animationFrameId = null;
  /**
   * Function that called in animation frame
   */

  var animationFrameCallback = function animationFrameCallback() {
    if (!isActive) {
      return;
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = scrollbarsRegister[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var scrollbar = _step.value;
        scrollbar.update();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    requestAnimationFrame(animationFrameCallback);
  };
  /**
   * Stop the loop if it wasn't active
   * @return {LoopControllerClass}
   */


  this.start = function () {
    if (!isActive) {
      isActive = true;
      animationFrameId && cancelAnimationFrame(animationFrameId);
      requestAnimationFrame(animationFrameCallback);
    }

    return _this;
  };
  /**
   * Stop the loop if it is active
   * @return {LoopControllerClass}
   */


  this.stop = function () {
    if (isActive) {
      isActive = false;
      animationFrameId && cancelAnimationFrame(animationFrameId);
      animationFrameId = null;
    }

    return _this;
  };
  /**
   * Return the array pf registered scrollbars
   * @return {Scrollbar[]}
   */


  this.getRegisteredScrollbars = function () {
    return [].concat(scrollbarsRegister);
  };
  /**
   * Add the scrollbar to list to iterate each loop
   * @param {Scrollbar} scrollbar
   * @return {LoopControllerClass}
   */


  this.registerScrollbar = function (scrollbar) {
    if (scrollbarsRegister.indexOf(scrollbar) === -1) {
      scrollbarsRegister.push(scrollbar);

      _this.start();
    }

    return _this;
  };
  /**
   * Remove the scrollbar from list to iterate each loop
   * @param {Scrollbar} scrollbar
   * @return {LoopControllerClass}
   */


  this.unregisterScrollbar = function (scrollbar) {
    var index = scrollbarsRegister.indexOf(scrollbar);

    if (index !== -1) {
      scrollbarsRegister.splice(index, 1);
    }

    return _this;
  };
}

var LoopController = exports.LoopController = new LoopControllerClass();
exports.default = LoopController;
/**
 * Return new instance of LoopControllerClass
 * @return {LoopControllerClass}
 */

function createLoopController() {
  return new LoopControllerClass();
}